<template>
  <div id="users_section">
    <CustomTabs v-model="activeKey" :tabs="tabs" />

    <users v-if="activeKey === 0" />
    <teams v-else-if="activeKey === 1" />
    <permission-set v-else-if="activeKey === 2" />
  </div>
</template>

<script setup>
import { ref, watch } from "vue";
import Users from "./Users.vue";
import Teams from "./Teams.vue";
import PermissionSet from "./PermissionSet.vue";
import CustomTabs from "@/src/components/CustomTabs.vue";

const tabs = [
  { title: "Users" },
  { title: "Teams" },
  { title: "Permission Sets" },
];

const activeKey = ref(parseInt(localStorage.getItem("settingsActiveKey")) || 0);

watch(activeKey, (newValue) => {
  localStorage.setItem("settingsActiveKey", newValue.toString());
});
</script>